import { render, staticRenderFns } from "./NoEligiblePortfolioDrawer.vue?vue&type=template&id=ea17aa3a"
import script from "./NoEligiblePortfolioDrawer.vue?vue&type=script&lang=js"
export * from "./NoEligiblePortfolioDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileImg: require('/skade-pwa/components/ui/atom/ProfileImg.vue').default,Truncate: require('/skade-pwa/components/ui/atom/Truncate.vue').default,WButton: require('/skade-pwa/components/ui/atom/WButton/WButton.vue').default})
